/**
 * ANB Analytics Loader (GA4 + Microsoft Clarity)
 * Human-gated analytics: prevents loading for bots/previews/non-prod
 */

(function() {
  'use strict';

  // CONFIG
  var GA4_ID = 'G-3SDZCQSD4Y';
  var CLARITY_ID = null; // Disabled for performance
  var PROD_HOST_PATTERN = /(^|\.)anbbaby\.com$/i;

  // Bot heuristics
  function isSuspiciousUA() {
    var ua = navigator.userAgent || '';
    return /(HeadlessChrome|PhantomJS|Puppeteer|Playwright|bot|crawl|spider|AhrefsBot|SemrushBot|MJ12bot|DotBot|Bytespider|SeznamBot|curl|wget)/i.test(ua);
  }

  function hasHeadlessSignals() {
    var webdriver = navigator.webdriver === true;
    var noPlugins = !navigator.plugins || navigator.plugins.length === 0;
    var noLangs = !navigator.languages || navigator.languages.length === 0;
    var hwConcurrency = (typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency === 0);
    return webdriver || (noPlugins && noLangs) || hwConcurrency;
  }

  function likelyBot() {
    return isSuspiciousUA() || hasHeadlessSignals();
  }

  // Visible-tab + human interaction gate
  function onVisible(fn) {
    if (document.visibilityState === 'visible') return fn();
    document.addEventListener('visibilitychange', function once() {
      if (document.visibilityState === 'visible') {
        document.removeEventListener('visibilitychange', once);
        fn();
      }
    });
  }

  function waitForHumanInteraction(timeoutMs) {
    return new Promise(function(resolve) {
      var done = false;
      function finish() {
        if (!done) {
          done = true;
          cleanup();
          resolve(true);
        }
      }
      var events = ['mousemove', 'scroll', 'keydown', 'touchstart'];
      function cleanup() {
        events.forEach(function(e) { window.removeEventListener(e, finish); });
      }
      events.forEach(function(e) {
        window.addEventListener(e, finish, { passive: true });
      });
      setTimeout(finish, timeoutMs || 5000);
    });
  }

  // Safe script loader
  function load(id, src) {
    if (id && document.getElementById(id)) return;
    var s = document.createElement('script');
    s.async = true;
    if (id) s.id = id;
    s.src = src;
    document.head.appendChild(s);
  }

  // Bail out in preview/non-prod/likely bot
  var isPreview = /[?&]preview_theme_id=/.test(location.search) || (typeof Shopify !== 'undefined' && Shopify.designMode);
  var isProdHost = PROD_HOST_PATTERN.test(location.hostname);
  if (isPreview || !isProdHost || likelyBot()) return;

  // Init GA4 + Clarity after visibility + interaction (5s delay for performance)
  onVisible(async function() {
    await waitForHumanInteraction(5000);

    // GA4
    if (GA4_ID && !window.gtag) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() { dataLayer.push(arguments); };
      load('ga4-lib', 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA4_ID));
      gtag('js', new Date());
      gtag('config', GA4_ID, { anonymize_ip: true });
    }

    // Microsoft Clarity
    if (CLARITY_ID && !window.clarity) {
      (function(c, l, a, r, i, t, y) {
        c[a] = c[a] || function() { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r);
        t.async = 1;
        t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', CLARITY_ID);
    }
  });
})();

